import { render, staticRenderFns } from "./VerifyPayment.vue?vue&type=template&id=f1501efe&scoped=true&lang=pug&"
import script from "./VerifyPayment.vue?vue&type=script&lang=js&"
export * from "./VerifyPayment.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPayment.vue?vue&type=style&index=0&id=f1501efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1501efe",
  null
  
)

/* custom blocks */
import block0 from "./VerifyPayment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VContainer,VLayout,VProgressLinear})
